<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iRvhzF/tc-custom/9781514004326.jpg?1696025161698" alt="This image is the cover for the book Finding Freedom in Constraint"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finding Freedom in Constraint
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The constraints of the spiritual life, practiced in community, are what set us free.</strong> Practicing spiritual disciplines can seem difficult, especially when we undertake them as isolated individuals. But we were never meant to practice them alone.</p> <p>Jared Patrick Boyd reveals how the constraints practiced in Christian community shape us into the way of Christ. He re-anchors the practices of constraint within the ascetic tradition of monasticism, religious orders, and the early church fathers. Boyd writes, "The constraints of a rule of life are what make life together, lived for one another, possible. A rule of life is not meant to be primarily personal, but communal. It's not primarily meant to guide my life. It is meant to describe our way of life together." Constraint is the practice of learning to pay deeper attention to the things in our inner world that prevent us from progressing in the school of love.</p> <p>Discover a deep conversation on freedom and constraint with six core practices of constraint that can form in us a greater freedom to be and become people who love as God loves. Enter into this vision with your local community (in small groups, church leadership teams, or families), and learn to make greater room to experience the love of God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jared Patrick Boyd, Todd Hunter
      </h2>
      
      <p class="authorDescription body article"><p>Jared Patrick Boyd is a pastor (Vineyard USA), spiritual director, and founding director of the Order of the Common Life, a missional monastic order reimagining religious vocations for the 21st century. In local pastoral ministry he works to bring together the contemplative, charismatic, and sacramental streams of the church. Jared and his wife have four daughters and live in the west-side neighborhood of Franklinton in Columbus, Ohio. He is the author of <em>Imaginative Prayer</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Intervarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fb059b0